import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel } from "common/models/utility-models/meta-model";

export class PrivacyMetaModel extends FormMetaModel {
    constructor() {
        super('Privacy', ROUTE_PATH.privacy, '', 2);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
       

        return {
           
       
           
            
        };
    }
}